<template>
  <div
    class="vt-lock-toggle"
    tabindex="-1"
    @click="$emit('input', !value)"
  >
    <i
      :class="classIcon"
      aria-hidden="true"
    />
  </div>
</template>

<script>

export default {
    name: 'VtLockToggle',
    props: {
        value: { type: Boolean, default: false }
    },
    computed: {
        icon() {
            return this.value ? ['fal', 'lock-alt'] : ['fal', 'lock-open-alt']
        },
        classIcon() {
            return this.value ? 'fas fa-thumbtack' : 'far fa-thumbtack'
        }
    }
}

</script>

<style lang="scss" scoped>

.vt-lock-toggle {
  color: vt-color(white-light);
  width: 32px;
  height: 32px;
  text-align: center;
}

.vt-lock-toggle i {
  font-size: 1.1rem;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

</style>
